import useGetFavoriteProducts from './useGetFavoriteProducts'

export default useGetFavoriteProducts
